import type { Event, EventVideoConference, EventWebinar } from 'models';
import { Modal, type ModalOptions } from 'ui';
import { OrganizationProvider } from 'features/organizations';
import { useCreateNodeOrganization } from '../hooks';
import { EditEventForm } from './edit-event-form';

export type EditEventModalOptions = {
  event: EventVideoConference | EventWebinar;
};

type P = {
  onCancel: () => void;
  onSuccess: (eventData: Event) => void;
  options: ModalOptions<EditEventModalOptions>;
};

const EditEventModal = ({ onCancel, onSuccess, options }: P) => {
  const createNodeOrganization = useCreateNodeOrganization();

  return (
    <Modal isOpened={options.isOpened} onCancel={onCancel} title="Edit Event" width="large">
      {options.isOpened ? (
        <Modal.HugContent>
          <OrganizationProvider id={options.event.channel?.organizationHashId}>
            {(organization) => (
              <EditEventForm
                event={options.event}
                onCancel={onCancel}
                onSuccess={onSuccess}
                organization={createNodeOrganization({
                  nodeOrganizationId: options.event.channel?.organization,
                  organization,
                })}
              />
            )}
          </OrganizationProvider>
        </Modal.HugContent>
      ) : null}
    </Modal>
  );
};

export default EditEventModal;
